<main id="main" class="main">
    <div class="row">
      <div class="col-md-12">
        <h6 class="admintitle">
          Underwriting Queues&nbsp;&nbsp;<i class="bi bi-info-circle" title="Underwriting is the process through which an individual or institution takes on financial risk for a fee. This risk most typically involves loans, insurance, or investments. The term underwriter originated from the practice of having each risk-taker write their name under the total amount of risk they were willing to accept for a specified premium.
          "></i>
        </h6>
      </div>
    </div>
   
    <br>
    <div class="row">
      <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_1"
          class="table text-nowrap">
       
          <thead>
            <tr>
              <th>Member id</th>
              <th>Member name</th>
              <th>In arbitration</th>
              <th>Date</th>
              <th>Status</th>

              <th style="text-align: right;">Actions</th>
  
            </tr>
          </thead>
  
          <!-- <tbody> -->
          <tbody>
            <tr *ngFor="let queue of adjudicationQueues; let i = index">
  
              <td>{{queue.customer.id}}</td>
              <td>{{queue.customer.firstName}} {{queue.customer.lastName}}</td>
              <td>{{queue.process}}</td>
              <td>{{handleProcessDate(queue.dateOfEntry)}}</td>
              <td>{{queue.status}}</td>


  
              <td style="cursor: pointer; text-align: right;">
                <i class="fa fa-eye" aria-hidden="true" title="view" data-bs-toggle="modal" style="color:green; margin-right: 10px;"
                data-bs-target="#ViewBroucherPDF" (click)="handleShowRequestDetails(queue)"></i>
             
             <!-- Button to open the second modal -->
             <i class="fa fa-edit" *ngIf="queue.status == 'Review'" aria-hidden="true" data-bs-toggle="modal" data-bs-target="#ViewBroucherPDF2" 
                (click)="handleShowRequestDetails2(queue)" title="Edit" style="color:#012970; margin-right: 10px;"></i>
                  <!-- Alarm Icon -->
                  <i class="fa fa-bell" *ngIf="queue.status == 'Review'" aria-hidden="true" data-bs-toggle="modal" data-bs-target="#ViewBroucherPDF4" 
                  
                  (click)="handleShowRequestDetails4(queue)" title="Set Reminder" style="color:#FF4500; margin-right: 10px;"></i>
                
                  <!-- Send Mail Icon -->
                  <i class="fa fa-envelope" *ngIf="queue.status == 'Review'" aria-hidden="true"  data-bs-toggle="modal" data-bs-target="#ViewBroucherPDF3" 
                  (click)="handleShowRequestDetails3(queue)"
                  title="Send Mail" style="color:#007BFF; margin-right: 10px;"></i>

                  <i class="fa fa-history" title="History" aria-hidden="true" data-bs-toggle="modal" data-bs-target="#ViewBroucherPDF5"
                style="cursor: pointer;color:blue;" (click)="showRequestHistory(queue)"></i>
              </td>
  
  
            </tr>
          </tbody>
  
        </table>
  
      </div>
  
  
    </div>
  </main>
  

  <div class="modal fade" data-bs-backdrop="static" id="ViewBroucherPDF" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content" id="dependent-content">
        <!-- Modal content for the first modal -->
        <div class="modal-header">
          <h6 class="modal-title">View Request details</h6>
          <div class="col-1 text-end ms-2 ms-md-2">
            <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
              data-bs-dismiss="modal"></i>
          </div>
        </div>
        <div class="modal-body" style="overflow-x: hidden;" *ngIf="requestQueueData">
            <b>Customer Details</b>

            <div class="flex items-start">
              <span class="font-medium w-32">Reason:</span>
              <ul class="list-disc ml-4 flex-1">
                <li *ngFor="let reason of reasonList">{{ reason }}</li>
                <li *ngIf="!reasonList || reasonList.length === 0" class="text-gray-500">None specified</li>
              </ul>
            </div>
            <div style="display: flex; width: 80%; justify-content: flex-start;">
                <div style="display: flex; gap: 10px; align-items: center; width: 50%;">
                    <p>Customer Type: </p>
                    <p>{{requestQueueData?.customer?.isCorporateAccount ? "CORPORATE" : "GIG"}}</p>
                </div>

                <div style="display: flex; gap: 10px; align-items: center;">
                    <p>Coverage Scenario: </p>
                    <p>{{handleCoverageChange(requestQueueData?.data?.coverageScenario)}}</p>
                </div>
            </div>

            <div style="display: flex; width: 80%; justify-content: flex-start;">
                <div style="display: flex; gap: 10px; align-items: center; width: 50%;">
                    <p>IGBMS Id: </p>
                    <p>{{requestQueueData?.customer?.fusebillCustomerId}}</p>
                </div>

                <div style="display: flex; gap: 10px; align-items: center;">
                    <p>Service Type: </p>
                    <p>{{ getServiceTypeLabel() }}</p>
                </div>
            </div>


            
<!-- 
            <div *ngIf="isDependent">
                <b>Dependent Details</b>
                <div *ngFor="let dep of dependentDetails">

                    <div style="display: flex; width: 80%; justify-content: flex-start;">
                        <div style="display: flex; gap: 10px; align-items: center; width: 50%;">
                            <p>Event: </p>
                            <p>{{requestQueueData?.data?.eventType}}</p>
                        </div>

                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Dependent Type: </p>
                            <p>Child</p>
                        </div>
                    </div>

                    <div style="display: flex; width: 80%; justify-content: flex-start;">
                        <div style="display: flex; gap: 10px; align-items: center; width: 50%;">
                            <p>First name: </p>
                            <p>{{dep.firstName}}</p>
                        </div>
            
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Last name: </p>
                            <p>{{dep.lastName}}</p>
                        </div>
                    </div>

                    <div style="display: flex; width: 80%; justify-content: flex-start;">
                        <div style="display: flex; gap: 10px; align-items: center; width: 50%;">
                            <p>Gender: </p>
                            <p>{{dep.gender}}</p>
                        </div>
            
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Date of birth: </p>
                            <p>{{handleProcessDate(dep.dob)}}</p>
                        </div>
                    </div>


                        <div style="display: flex; width: 80%; justify-content: flex-start;">
                            <div style="display: flex; gap: 10px; align-items: center; width: 50%;">
                                <p>Is Dependent Covered: </p>
                                <p>{{ dep.coveredByAnotherPlan ? 'YES' : 'NO' }}</p>
                            </div>
                
                            <div style="display: flex; gap: 10px; align-items: center;">
                                <p>Carrier Name: </p>
                                <p>{{dep.carrierName ? dep.carrierName : 'NA'}}</p>
                            </div>
                        </div>

                        <div style="display: flex; width: 80%; justify-content: flex-start;">
                            <div style="display: flex; gap: 10px; align-items: center; width: 50%;">
                                <p>Graduation Date: </p>
                                <p>{{dep.graduationDate ? dep.graduationDate : 'NA'}}</p>
                            </div>
                
                            <div style="display: flex; gap: 10px; align-items: center;">
                                <p>Dependent with special Needs: </p>
                                <p>{{dep.specialNeeds ? 'YES' : 'NO'}}</p>
                            </div>
                        </div>
                </div>
            </div> -->


            <div *ngIf="isDependent" style="margin-top: 20px; width: 100%; overflow-x: auto;margin-bottom: 30px;">
              <b>Dependent Details</b>
              <table style="border-collapse: collapse; width: max-content; min-width: 100%; margin-top: 10px;" class="beneficiaryTable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Gender</th>
                    <th>Date of Birth</th>
                    <th>Is Dependent Covered</th>
                    <th>Carrier Name</th>
                    <th>Graduation Date</th>
                    <th>Special Needs</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dep of dependentDetails; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ dep.firstName }}</td>
                    <td>{{ dep.lastName }}</td>
                    <td>{{ dep.gender }}</td>
                    <td>{{ handleProcessDate(dep.dob) }}</td>
                    <td>{{ dep.coveredByAnotherPlan ? 'YES' : 'NO' }}</td>
                    <td>{{ dep.carrierName || 'NA' }}</td>
                    <td>{{ dep.graduationDate || 'NA' }}</td>
                    <td>{{ dep.specialNeeds ? 'YES' : 'NO' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            



            <div *ngIf="isSpouse" style="margin-top: 20px; width: 100%; overflow-x: auto; margin-bottom: 30px;" >
              <b>Spouse Details</b>
              <div style="min-width: 800px;">
                <table style="border-collapse: collapse; width: max-content; min-width: 100%;"  class="beneficiaryTable">
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Gender</th>
                      <th>Date of Birth</th>
                      <th *ngIf="spouseDetails.coveredByAnotherPlan">Is Spouse Covered</th>
                      <th *ngIf="spouseDetails.coveredByAnotherPlan">Carrier Name</th>
                      <th *ngIf="spouseDetails.coveredByAnotherPlan">Coverage</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ spouseDetails.firstName }}</td>
                      <td>{{ spouseDetails.lastName }}</td>
                      <td>{{ spouseDetails.gender }}</td>
                      <td>{{ handleProcessDate(spouseDetails.dob) }}</td>
                      <td *ngIf="spouseDetails.coveredByAnotherPlan">YES</td>
                      <td *ngIf="spouseDetails.coveredByAnotherPlan">{{ spouseDetails.carrierName }}</td>
                      <td *ngIf="spouseDetails.coveredByAnotherPlan">{{ spouseDetails.coverage }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            

            <!-- <div *ngIf="isSpouse">
                <b>Spouse Details</b>

                    <div style="display: flex; width: 100%; justify-content: space-between;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Event: </p>
                            <p>{{requestQueueData?.data?.eventType}}</p>
                        </div>

                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Dependent Type: </p>
                            <p>Spouse</p>
                        </div>
                    </div>

                    <div style="display: flex; width: 100%; justify-content: space-between;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>First name: </p>
                            <p>{{spouseDetails.firstName}}</p>
                        </div>
            
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Last name: </p>
                            <p>{{spouseDetails.lastName}}</p>
                        </div>
                    </div>

                    <div style="display: flex; width: 100%; justify-content: space-between;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Gender: </p>
                            <p>{{spouseDetails.gender}}</p>
                        </div>
            
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Date of birth: </p>
                            <p>{{handleProcessDate(spouseDetails.dob)}}</p>
                        </div>
                    </div>


                    <div *ngIf="spouseDetails.coveredByAnotherPlan" style="display: flex; width: 100%; justify-content: space-between;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Name of the carrier: </p>
                            <p>{{spouseDetails.carrierName}}</p>
                        </div>
            
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <p>Coverage: </p>
                            <p>{{spouseDetails.coverage}}</p>
                        </div>
                    </div>
            </div> -->


            <div *ngIf="isSpouse || isDependent" style="margin-top: 20px; width: 100%; overflow-x: auto; margin-bottom: 30px;" >
              <div style="min-width: 800px;">

              <b>Plan Changes</b>

                <table id="table"  style="border-collapse: collapse; width: max-content; min-width: 100%;"  class="beneficiaryTable">
            <thead>
              <tr>
                <th rowspan="2" class="text-center">Id</th>
                <th class="text-center">Plan Name</th>
                <th class="text-center">Price</th>
                <th class="text-center">Tax</th>
                <th class="text-center">Total</th>
              </tr>
              <!-- <tr>
                <th class="text-center">Old</th>
                <th class="text-center">New</th>
                <th class="text-center">Old</th>
                <th class="text-center">New</th>
                <th class="text-center">Old</th>
                <th class="text-center">New</th>
                <th class="text-center">Old</th>
                <th class="text-center">New</th>
              </tr> -->
            </thead>
            <tbody>
              <tr *ngFor="let data of plansSummaryObj; let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center" >{{ data.planproductname }} - {{data.planCoverage}}</td>
                <td class="text-center">${{ data.planPrice }}</td>
                <td class="text-center">${{ data.tax }}</td>
                <td class="text-center">${{ data.totalPrice }}</td>
              </tr>
              <!-- <tr>
                <td class="text-center"><b>Grand total</b></td>
                <td style="text-align: right;" colspan="8">${{totalSummaryPrice}}</td>
              </tr> -->
              <tr></tr>
            </tbody>
          </table>
        </div>  

                
            </div>
         
              

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel (click)="closePopup('ViewBroucherPDF')">Close</button>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="requestQueueData" class="modal fade" data-bs-backdrop="static" id="ViewBroucherPDF2" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <!-- Modal content for the second modal -->
        <div class="modal-header">
          <h6 class="modal-title">Edit request details</h6>
          <div class="col-1 text-end ms-2 ms-md-2">
            <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
              data-bs-dismiss="modal"></i>
          </div>
        </div>
        <div class="modal-body">
            <!-- Align Effective Date and Provision question side by side -->
            <div class="d-flex" style="align-items: flex-start;" *ngIf="!showChildForm">
              <!-- Effective Date Input -->
              <div class="form-group" style="width: 30%; margin-right: 20px;">

                <label id="modal-labels"
                >Plan Effective Date<span style="color: red">*</span></label
            >
            <!-- <input type="text" class="form-control date" formControlName="effectiveDate" placeholder="mm-dd-yyyy"> -->
            <select class="form-select border border-dark" id="planEffectiveDate" placeholder="Select"
            style="font-size: 12px;"
            [(ngModel)]="planEffectiveDate">
            <option value="null" label="" selected disabled>Select</option>
            <option *ngFor="let name of planEnrollmentDates" [value]="name" [label]="name">
                {{ name }}
            </option>
            </select>

              </div>

              <div class="form-group" style="width: 30%; margin-right: 20px;">
                <label for="status">Request Status</label>
                <select class="form-control" id="status" [(ngModel)]="adminStatus" (change)="onStatusChange($event)">
                  <option value="" disabled selected>Select Status</option>
                  <option value="Done">Done</option>
                  <option value="Failed">Failed</option>
                </select>
              </div>

             
          
              <!-- Provision Question -->
              <!-- <div class="form-group" style="width: 40%;">
                <label for="provision">Do you want to provision?</label><br>
                <div style="display: flex; gap: 10px;">
                  <div class="form-check" style="display: flex; align-items: center; gap: 5px;">
                    <input class="form-check-input" type="radio" id="provisionYes" name="provision" value="Yes" [(ngModel)]="provision">
                    <label class="form-check-label" for="provisionYes">Yes</label>
                  </div>
                  <div class="form-check" style="display: flex; align-items: center; gap: 5px;">
                    <input class="form-check-input" type="radio" id="provisionNo" name="provision" value="No" [(ngModel)]="provision">
                    <label class="form-check-label" for="provisionNo">No</label>
                  </div>
                </div>
              </div> -->
            </div>

            <div *ngIf="adminStatus == 'Failed'">
              <div class="form-group">
                <label for="reason">Respond back to member</label>
                <textarea class="form-control" id="reason" rows="3" [(ngModel)]="respondReason"></textarea>
              </div>
            </div>


            <div style="margin-top: 12px;">
              <span *ngIf="isSpouse && !showChildForm"><b>Spouse Information</b></span>
              <form [formGroup]="spouseform" *ngIf="isSpouse && !showChildForm">
                <div class="row">
                  <div class="col-md-12 form-group">
                    <label id="modal-labels"
                      >Is Your dependent covered by another plan<span style="color: red">*</span></label
                    >
                  </div>
                </div>
                <div class="row" >
                  <div class="col-3 mt-1">
                    <input
                      type="radio"
                      [value]="true"
                      name="coveredByAnotherPlan"
                      formControlName="coveredByAnotherPlan"
                      [checked]="dependentCoverage === 'open'"
                      (click)="openDependentCoverage('open')"
                    />&nbsp;<label id="radio-labels" class="align-text-top">Yes</label>
                  </div>
                  <div class="col-3 mt-1">
                    <input
                      type="radio"
                      [value]="false"
                      name="coveredByAnotherPlan"
                      formControlName="coveredByAnotherPlan"
                      [checked]="dependentCoverage === 'close'"
                      (click)="openDependentCoverage('close')"
                    />&nbsp;<label id="radio-labels" class="align-text-top">No</label>
                  </div>
                  <div
                    *ngIf="
                    spouseForm['coveredByAnotherPlan'].touched &&
                    spouseForm['coveredByAnotherPlan'].invalid
                    "
                    class="help-block text-danger"
                  >
                    <div
                      *ngIf="
                      spouseForm['coveredByAnotherPlan'].errors &&
                      spouseForm['coveredByAnotherPlan'].errors['required']
                      "
                    >
                      {{ lang?.Please_choose_dependent_insurance_status }}
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="isSpouse">
                  <div class="col-md-3 form-group">
                    <label id="modal-labels"
                      >First Name<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      placeholder="{{lang?.First_Name}}"
                      id="firstName"
                      formControlName="firstName"
                      class="form-control"
                      (keypress)="
                        (($event.charCode >= 65 && $event.charCode < 91) ||
                          ($event.charCode >= 97 && $event.charCode < 123) ||
                          $event.charCode == 32)
                      "
                      (input)="checkFirstCharacter($event, dependentform)"
                    />
                    <div
                      *ngIf="
                        spouseForm['firstName'].touched &&
                        spouseForm['firstName'].invalid
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          spouseForm['firstName'].errors &&
                          spouseForm['firstName'].errors['required']
                        "
                      >
                        Please enter first name
                      </div>
                      <div
                        *ngIf="
                          spouseForm['firstName'].errors &&
                          spouseForm['firstName'].errors['minlength']
                        "
                      >
                      First name should be atleast 1 character
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 form-group">
                    <label id="modal-labels"
                      >Last Name<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      placeholder="{{lang?.Last_Name}}"
                      id="lastName"
                      formControlName="lastName"
                      class="form-control"
                      (keypress)="
                        (($event.charCode >= 65 && $event.charCode < 91) ||
                          ($event.charCode >= 97 && $event.charCode < 123) ||
                          $event.charCode == 32)
                      "
                      (input)="checkFirstCharacter($event, dependentform)"
                    />
                    <div
                      *ngIf="
                        spouseForm['lastName'].touched &&
                        spouseForm['lastName'].invalid
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          spouseForm['lastName'].errors &&
                          spouseForm['lastName'].errors['required']
                        "
                      >
                        Please enter last name
                      </div>
                      <div
                        *ngIf="
                          spouseForm['lastName'].errors &&
                          spouseForm['lastName'].errors['minlength']
                        "
                      >
                      Last name should be atleast 1 character
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 form-group">
                    <label id="modal-labels"
                      >Gender<span style="color: red">*</span></label
                    >
                    <select class="form-select form-control" formControlName="gender"  style="font-size: 12px !important;">
                      <option value="" disabled>{{ lang?.Select }}</option>
                      <option
                        *ngFor="let gender of genders"
                        value="{{ gender }}"
                      >
                        {{ gender }}
                      </option>
                    </select>
                    <div
                      *ngIf="
                        spouseForm['gender'].touched &&
                        spouseForm['gender'].invalid
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          spouseForm['gender'].errors &&
                          spouseForm['gender'].errors['required']
                        "
                      >
                      Please select gender
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 form-group">
                    <label id="modal-labels"
                      >Date Of Birth<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      placeholder="MM-DD-YYYY"
                      class="form-control checking-field"
                      id="dob"
                      formControlName="dob"
                      [minDate]="minDatechild"
                      [maxDate]="maxDatechild"
                      bsDatepicker
                      [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"
                    />
                    <div
                      *ngIf="
                        spouseForm['dob'].touched && spouseForm['dob'].invalid
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          spouseForm['dob'].errors &&
                          spouseForm['dob'].errors['required']
                        "
                      >
                      Please choose date of birth
                      </div>
                    </div>

                    <div
                    *ngIf="
                      spouseForm['dob'].touched && spouseForm['dob'].status=='INVALID'
                    "
                    class="help-block text-danger"
                  >
                    <div
                      *ngIf="
                        spouseForm['dob'].errors &&
                        spouseForm['dob'].errors['ageError']
                      "
                    >
                      Date of birth must be above 18
                    </div>
                  </div>
                  </div>
                </div>
                <div
                  class="row">
                  <div *ngIf="dependentCoverage === 'open'" class="col-3 form-group">
                    <label id="modal-labels"
                      >Name of the carrier<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      placeholder="Name of the Carrier"
                      class="form-control"
                      formControlName="insurer"
                      id="carrierName"
                      (keypress)="
                        (($event.charCode >= 65 && $event.charCode < 91) ||
                          ($event.charCode >= 97 && $event.charCode < 123) ||
                          $event.charCode == 32)
                      "
                      (input)="checkFirstCharacter($event, dependentform)"
                    />
                    <div
                      *ngIf="
                        spouseForm['insurer'].touched &&
                        spouseForm['insurer'].invalid
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          spouseForm['insurer'].errors &&
                          spouseForm['insurer'].errors['required']
                        "
                      >
                        Please enter name of carrier
                      </div>
                    </div>
                  </div>

                  <div *ngIf="dependentCoverage === 'open'" class="col-3 form-group">
                    <label id="modal-labels"
                      >Coverage<span style="color: red">*</span></label
                    >
                    <select class="form-select" formControlName="healthPlan" style="font-size: 12px;">
                      <option value="" disabled>Select Coverage</option>
                      <option
                      value="single"
                    >
                      Single
                    </option>
                      <option
                      value="couple"
                    >
                      Couple
                    </option>
                    <option
                    value="family"
                  >
                    Family
                  </option>
                    </select>
                    <div
                      *ngIf="
                        spouseForm['healthPlan'].touched &&
                        spouseForm['healthPlan'].invalid
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          spouseForm['healthPlan'].errors &&
                          spouseForm['healthPlan'].errors['required']
                        "
                      >
                        Please enter name of carrier
                      </div>
                    </div>
                  </div>


                </div>



                <div class = "showLine" *ngIf="dependentType == 'spouse'"></div>
                <div class="row">
                </div>
              </form>

            </div>

            <div *ngIf="isDependent">
              <div class = "showLine" ></div>
              <span><b>Children Information</b></span>
              <div *ngIf="dependentDetails.length==0">
                <span style="font-size: 12px; font-style: italic; opacity: 80%;">No children to show</span>
              </div>
              <div class="showChildDetailsTable" style="margin-top: 20px;" *ngIf="!showChildForm && dependentDetails.length > 0">
                <table id="table" class="beneficiaryTable">
                  <thead>
                    <tr>
                      <!-- <th>Benefactor</th> -->
                      <!-- <th>Type</th> -->
                      <th>Name</th>
                      <!-- <th>Name</th> -->
                      <!-- <th>Gender</th> -->
                      <th>Date of birth</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let child of dependentDetails; let i = index">
                      <!-- <td><input class="form-control view text-capitalize" style="width:100px;" disabled ngModel={{child.customerType}}/></td> -->
                      <!-- <td><input class="form-control view text-capitalize" style="width:120px;" disabled value={{removeUnderscores(child.type)}}/></td> -->
                      <td class="text-center">
                        {{child.firstName + ' '+ child.lastName}}
                      </td>
                      <!-- <td class="text-center">
                        {{child.gender}}
                      </td> -->
                      <td class="text-center">
                        {{momentDateformat(child.dob)}}
                      </td>
                      <td class="text-center">
                        <i class="fa fa-pencil"
                        role="button"
                        aria-hidden="true" (click)="updateChildDetails_v2(child, i)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>


            <form [formGroup]="pureDependentform" class="pureDependentform"  *ngIf="showChildForm">
              <div class="row">
                <div class="col-md-4 form-group">
                  <label id="modal-labels"
                    >First Name<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    placeholder="First Name"
                    id="firstName"
                    formControlName="firstName"
                    class="form-control"
                    (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    "
                    (input)="checkFirstCharacter($event, pureDependentform)"
                  />
                  <div
                    *ngIf="
                      dependentPureForm['firstName'].touched &&
                      dependentPureForm['firstName'].invalid
                    "
                    class="help-block text-danger"
                  >
                    <div
                      *ngIf="
                        dependentPureForm['firstName'].errors &&
                        dependentPureForm['firstName'].errors['required']
                      "
                    >
                      Please enter first name
                    </div>
                    <div
                      *ngIf="
                        dependentPureForm['firstName'].errors &&
                        dependentPureForm['firstName'].errors['minlength']
                      "
                    >
                    First name should be atleast 1 character
                      <!-- {{
                        lang?.First_Name_minimum_of_2_Characters_and_without_numbers
                      }} -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels"
                    >Last Name<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    placeholder="Last Name"
                    id="lastName"
                    formControlName="lastName"
                    class="form-control"
                    (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    "
                    (input)="checkFirstCharacter($event, pureDependentform)"
                  />
                  <div
                    *ngIf="
                      dependentPureForm['lastName'].touched &&
                      dependentPureForm['lastName'].invalid
                    "
                    class="help-block text-danger"
                  >
                    <div
                      *ngIf="
                        dependentPureForm['lastName'].errors &&
                        dependentPureForm['lastName'].errors['required']
                      "
                    >
                      Please enter last name
                    </div>
                    <div
                      *ngIf="
                        dependentPureForm['lastName'].errors &&
                        dependentPureForm['lastName'].errors['minlength']
                      "
                    >
                    Last name should be atleast 1 character
                      <!-- {{
                        lang?.Last_Name_minimum_of_2_Characters_and_without_numbers
                      }} -->
                    </div>
                  </div>
                </div>
                <!-- <div class="col-3 form-group">
                  <label id="modal-labels"
                    >Gender<span style="color: red">*</span></label
                  >
                  <select class="form-select" formControlName="gender"   style="font-size: 12px !important;">
                    <option value="" disabled>Select</option>
                    <option
                    *ngFor="let gender of genders"
                      value="{{ gender }}"
                    >
                      {{ gender }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      dependentPureForm['gender'].touched &&
                      dependentPureForm['gender'].invalid
                    "
                    class="help-block text-danger"
                  >
                    <div
                      *ngIf="
                        dependentPureForm['gender'].errors &&
                        dependentPureForm['gender'].errors['required']
                      "
                    >
                      Please select gender
                    </div>
                  </div>
                </div> -->
                <div class="col-4 form-group">
                  <label id="modal-labels"
                    >Date Of Birth<span style="color: red">*</span></label
                  >
                  <!-- <input type="text" id="dob" formControlName="dob" placeholder="mm-dd-yyyy" class="form-control date"> -->
                  <input
                    type="text"
                    placeholder="MM-DD-YYYY"
                    class="form-control checking-field"
                    id="dob"
                    formControlName="dob"
                    [minDate]="minDatechild"
                    [maxDate]="maxDatechild"
                    bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"
                  />
                  <div
                    *ngIf="
                      dependentPureForm['dob'].touched && dependentPureForm['dob'].invalid
                    "
                    class="help-block text-danger"
                  >
                    <div
                      *ngIf="
                        dependentPureForm['dob'].errors &&
                        dependentPureForm['dob'].errors['required']
                      "
                    >
                      Please enter Date of birth
                    </div>
                  </div>
                </div>
              </div>
              <div class = "isInsuranceCheck" style="display: flex; gap: 30px;">
                <div class="leftSide">
                  <div class="row" style="display: flex; align-items: end;">
                    <div class="col-12 form-group">
                      <label id="modal-labels"
                        >Is your dependent covered by another Health and or Dental Insurance plan<span style="color: red">*</span></label
                      >
                    </div>
  
                  </div>
                  <div class="row">
                    <div class="col-3 mt-1">
                      <input
                        type="radio"
                        [value]="true"
                        name="coveredByAnotherPlan"
                        formControlName="coveredByAnotherPlan"
                        [checked]="childCoverage === true"
                        (click)="openDependentCoverage('open')"
                      />&nbsp;<label id="radio-labels" class="align-text-top">Yes</label>
                    </div>
                    <div class="col-3 mt-1">
                      <input
                        type="radio"
                        [value]="false"
                        name="coveredByAnotherPlan"
                        formControlName="coveredByAnotherPlan"
                        [checked]="childCoverage === false"
                        (click)="openDependentCoverage('close')"
                      />&nbsp;<label id="radio-labels" class="align-text-top">No</label>
                    </div>
                    <div
                      *ngIf="
                        dependentPureForm['coveredByAnotherPlan'].touched &&
                        dependentPureForm['coveredByAnotherPlan'].invalid
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          dependentPureForm['coveredByAnotherPlan'].errors &&
                          dependentPureForm['coveredByAnotherPlan'].errors['required']
                        "
                      >
                      Please choose dependent insurance status
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rightSide" style="flex-grow: 1;">
                  <div class="row">
                    <div class="col-8 form-group" *ngIf="showChildForm && dependentChildCoverage === 'open'">
                      <label id="modal-labels"
                        >Name of the carrier<span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        placeholder="Name of the Carrier"
                        class="form-control"
                        formControlName="carrierName"
                        id="carrierName"
                        (keypress)="
                          (($event.charCode >= 65 && $event.charCode < 91) ||
                            ($event.charCode >= 97 && $event.charCode < 123) ||
                            $event.charCode == 32)
                        "
                        (input)="checkFirstCharacter($event, pureDependentform)"
                      />
                      <div
                        *ngIf="
                          dependentPureForm['carrierName'].touched &&
                          dependentPureForm['carrierName'].invalid
                        "
                        class="help-block text-danger"
                      >
                        <div
                          *ngIf="
                            dependentPureForm['carrierName'].errors &&
                            dependentPureForm['carrierName'].errors['required']
                          "
                        >
                        Please enter name of carrier
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="row mt-2">
                <div class="col-md-8 align-items-center">
                  <div class="row">
                    <div class="col-1" id="checkbox">
                      <input
                        type="checkbox"
                        value="true"
                        formControlName="specialNeeds"
                        [checked]="specialNeeds === 'true'"
                      />
                    </div>
                    <div class="col-11">
                      <span id="modal-labels">Dependent with Special Needs</span
                      >&nbsp;
                    </div>
                  </div>
                </div>
                <!-- <div *ngIf="dependentPureForm['specialNeeds'].touched && dependentPureForm['specialNeeds'].invalid" class="help-block text-danger">
                                <div *ngIf="dependentPureForm['specialNeeds'].errors && dependentPureForm['specialNeeds'].errors['required']">Please enter</div>
                            </div> -->
              </div>
              <div class="row mt-2">
                <div class="col-md-8 align-items-center">
                  <div class="row">
                    <div class="col-1" id="checkbox">
                      <input
                        type="checkbox"
                        value="true"
                        formControlName="postSecondaryStudent"
                        [checked]="postSecondaryStudent === true"
                        (change)="openGraduationDate($event)"
                      />
                    </div>
                    <div class="col-11">
                      <span id="modal-labels">Post Secondary Student</span
                      >&nbsp;
                    </div>
                  </div>
                </div>
                <!-- <div *ngIf="dependentPureForm['postSecondaryStudent'].touched && dependentPureForm['postSecondaryStudent'].invalid" class="help-block text-danger">
                                <div *ngIf="dependentPureForm['postSecondaryStudent'].errors && dependentPureForm['postSecondaryStudent'].errors['required']">lang?.Please_enter_first_name</div>
                            </div> -->
              </div>
              <div class="row">
  
                <div class="col-md-3 col-3 form-group"  *ngIf="postSecondaryStudent && graduationDate">
                  <label id="modal-labels"
                    >Graduation Day<span style="color: red">*</span></label
                  >
                  <!-- <input type="text" placeholder="mm-dd-yyyy" class="form-control date" name="graduationDate" formControlName="graduationDate"> -->
                  <input
                    type="text"
                    placeholder="MM-DD-YYYY"
                    class="form-control checking-field"
                    name="graduationDate"
                    formControlName="graduationDate"
                    placement="top"
                    [minDate]="minDatechild" [maxDate]="maxDatechild"
                    bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"
                  />
                </div>
  
  
  
  
  
  
                <!-- <div *ngIf="dependentCoverage === 'open'" class="col-3 form-group">
                  <label id="modal-labels"
                    >Upgrade Plan<span style="color: red">*</span>
                    <i style="margin-left: 5px;" class="fa fa-info-circle" title="Upgrading your plan will result in a price change, but you can keep the same coverage." aria-hidden="true"></i>
                    </label
                  >
                  <select class="form-select" formControlName="upgradePlan" (change)="handleUpgradePlan2($event)">
                    <option value="" disabled>Select</option>
                    <option
                    value="true"
                  >
                    Yes
                  </option>
                    <option
                    value="false"
                  >
                    No
                  </option>
                  </select>
                  <div
                    *ngIf="
                      dependentPureForm['carrierName'].touched &&
                      dependentPureForm['carrierName'].invalid
                    "
                    class="help-block text-danger"
                  >
                    <div
                      *ngIf="
                        dependentPureForm['carrierName'].errors &&
                        dependentPureForm['carrierName'].errors['required']
                      "
                    >
                      {{ lang?.Please_enter_name_of_carrier }}
                    </div>
                  </div>
                </div> -->
  
              </div>
  
            </form>
            
          
            <!-- Reason Input -->
            <div class="form-group" *ngIf="!showChildForm">
              <label for="reason">Reason</label>
              <textarea class="form-control" id="reason" rows="3" [(ngModel)]="reason"></textarea>

              <div
                *ngIf="invalidReason"
                class="help-block text-danger"
              >
                Please enter reason
              </div>
            </div>

            <div *ngIf="showPlanDetails == true && specialpackages?.length > 0"   style="margin-top: 800px;" class="plansscreen">
                    <div *ngFor="let package of specialpackages">
                      <div
                        class="d-flex gap-1"
                        *ngIf="isGroupsNotEmpty(package.groups)"
                      >
                        <span style="color: black; font-size: 12px;margin-top: 10px;"
                          >{{ package.name }}
                          <!-- <span title="Restricted"
                            *ngIf="package.restrictedAccess" class="ps-1">(R)</span>-->
                        </span>
                        <div
                          *ngIf="role === 'ADMINISTRATOR'"
                          title="{{
                            getTextForTooltip1(
                              package.published,
                              package.restrictedAccess
                            )
                          }}"
                          [ngStyle]="{
                            'border-color': getColorForPlans1(
                              package.published,
                              package.restrictedAccess
                            )
                          }"
                          class="outer my-auto col-2"
                          data-bs-toggle=""
                        >
                          <span
                            class="inner"
                            [ngStyle]="{
                              background: getColorForPlans1(
                                package.published,
                                package.restrictedAccess
                              )
                            }"
                          ></span>
                        </div>
                                      </div>
        
                      <div
                        *ngIf="displayPackage"
                        [ngClass]="{ wraptext: displayPackage }"
                        class="m-1 p-3"
                      >
                        <div
                          *ngFor="let groups of package?.groups | keyvalue"
                          class="d-flex gap-3 overflow-hidden"
                        >
                          <div *ngFor="let group of getGroups(groups)">
                            <div
                              *ngFor="let plan of group.plans; let i = index"
                              class="d-flex flex-wrap gap-3"
                            >
                              <div
                                class="package-groups col-md-4 mt-2"
                                *ngFor="
                                  let product of plan.productAddonssNames;
                                  let j = index
                                "
                                title=""
                              >
                                <div
                                  (mouseover)="hoverStates[product] = true"
                                  (mouseout)="hoverStates[product] = false"
                                  class="plantitle d-flex gap-3"
                                  [style.background-color]="
                                    plan.isBundle == false
                                      ? plan.productAddonss[product][0]?.planlevel
                                          ?.backgroundColor || '#5E172E'
                                      : group.backgroundColor || '#5E172E'
                                  "
                                >
                                  <span
                                    *ngIf="role === 'ADMINISTRATOR'"
                                    title="{{
                                      getTextForTooltip(
                                        plan.published?.data[0],
                                        plan.restricted
                                      )
                                    }}"
                                    [ngStyle]="{
                                      'border-color': getColorForPlans(
                                        plan.published?.data[0],
                                        plan.restricted,
                                        plan.name,
                                        plan
                                      )
                                    }"
                                    class="outer1 my-auto"
                                    data-bs-toggle=""
                                  >
                                    <span
                                      class="inner"
                                      [ngStyle]="{
                                        background: getColorForPlans(
                                          plan.published?.data[0],
                                          plan.restricted,
                                          plan.name,
                                          plan
                                        )
                                      }"
                                    ></span>
                                  </span>
                                  <span
                                    class="productname"
                                    [title]="product.length > 20 ? product : ''"
                                    [class.marquee]="
                                      product.length > 20 && hoverStates[product]
                                    "
                                    >{{
                                      product.length > 20
                                        ? hoverStates[product]
                                          ? product
                                          : (product | slice : 0 : 20) + "..."
                                        : product
                                    }}
                                    <!-- <span title="Restricted" *ngIf="plan.restricted"
                                      class="text-white pe-1">(R)</span> -->
                                  </span>
                                </div>
        
                                <!-- <div *ngIf=" plan.isBundle==true;else planfeature">
                                  <div class="planbody" *ngIf="group.planLevelFeatures">
        
                                    <li class="featuutrebody"
                                      *ngFor="let features of group.planLevelFeatures">
                                      <strong>{{ features.feature.name }}</strong> <br />
                                      <p [innerHTML]="features.description"></p>
                                    </li>
                                  </div>
                                </div> -->
        
                                <!-- <ng-template #planfeature>
                                  <div class="planbody"
                                    *ngIf="plan.productAddonss[product][0].planlevel.planLevelFeatures">
        
                                    <li class="featuutrebody"
                                      *ngFor="let features of plan.productAddonss[product][0].planlevel.planLevelFeatures">
                                      <strong>{{ features.feature.name }}</strong> <br />
                                      <p [innerHTML]="features.description"></p>
                                    </li>
                                  </div>
        
                                </ng-template> -->
        
                                <div class="plancoverage">
                                  <li
                                    class="plansCoverageDetails"
                                    *ngFor="
                                      let coverage of plan.productAddonss[product];
                                      let k = index
                                    "
                                  >
                                    <div *ngIf="coverage?.isShown==true"
                                      class="d-flex justify-content-between"
                                      [style.color]="
                                        plan.isBundle == false
                                          ? plan.productAddonss[product][0]?.planlevel
                                              ?.backgroundColor || '#5E172E'
                                          : group.backgroundColor || '#5E172E'
                                      "
                                      title="{{ coverage.planCoverageUI }}"
                                    >
                                      <div class="d-flex my-auto gap-1">
                                        <div class="my-auto">
                                          <!-- [disabled]="package.selected" -->
                                          <input type="checkbox" #planCheckdetails
                                          id="plancheck{{plan.isBundle ? plan.id : plan.productAddonss[product][k].planlevel.id }}"
                                          class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} coverage{{coverage.planCoverageUI | uppercase}}"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                          plan.planCoverage
                                        }}##{{
                                          plan.productAddonss[product][k].calculatedTax.price
                                        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                          plan.frqMonthly
                                        }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                          group.parentId
                                        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                          plan.packageId
                                        }}##0##{{ plan.planOptions }}##{{
                                          plan.productAddonss[product][k].id
                                        }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{ group.disallowedPlanLevels }}"
        
                                            (change)="
                                            onCheckboxChange(
                                              $event,
                                              package.allowMultiple,
                                              plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
                                              plan.planOptions,
                                              group.parentId,
                                              package.name,
                                              group.name,
                                              plan.planCoverage,
                                              0,
                                              0,
                                              0,
                                              0,
                                              $event,
                                              i,
                                              j,
                                              k,
                                              plan,
                                              plan.productAddonss[product][k],package,group,coverage.planCoverageUI)">
        
                                        </div>
        
                                        <div style="margin-top: -1px">
                                          {{ coverage.planCoverageUI }}
                                        </div>
                                      </div>
                                      <div
                                        class=""
                                        [style.color]="
                                          plan.isBundle == false
                                            ? plan.productAddonss[product][0]?.planlevel
                                                ?.backgroundColor || '#5E172E'
                                            : group.backgroundColor || '#5E172E'
                                        "
                                      >
                                        {{ currencySymbol
                                        }}{{ coverage.price | number : "1.2-2"
                                        }}<small>*</small>
                                      </div>
                                    </div>
        
                                    <!-- <span class="overflow-ellipsis2" style="float: right; color: white">
                        {{ currencySymbol}}{{ coverage.price | number:
                        "1.2-2"}}<small>*</small></span>
                      <span class="overflow-ellipsis" style="float: left; color: white"
                        title={{coverage.planCoverageUI}}>
                        <span> <input type="checkbox" [disabled]="package.selected"
                            [checked]="coverage.selected"
                            id="plancheck{{ plan.productAddonss[product][k].id }}"
                            class="plancheckbox{{ package.id }} plancv"
                            attr.data="{{ package.name }}##{{ group.name }}##{{
                            plan.planCoverage
                            }}##{{plan.productAddonss[product][k].calculatedTax?.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                            plan.frqMonthly
                            }}##{{ package.optIn }}##{{
                            group.disallowedPlanLevels
                            }}##{{ group.parentId }}##{{ group.id }}##{{
                            plan.name
                            }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}" (change)="
                            onCheckboxChange(
                              $event,
                              package.allowMultiple,
                              group.disallowedPlanLevels,
                              plan.planOptions,
                              group.parentId,
                              package.name,
                              group.name,
                              plan.planCoverage,
                              0,
                              0,
                              0,
                              0,
                              $event,
                              i,
                              j,
                              k,
                              plan,
                              plan.productAddonss[product][k],package,group
                            )
                          "></span>
        
        
                        <span>{{coverage.planCoverageUI}}</span>
                      </span><span class="clearfix"></span> -->
                                  </li>
                                </div>
                              </div>
                              </div>
        
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div *ngIf="showPlanDetails == true" style="margin-top: 800px;">

                    <div *ngFor="let package of mainarrayFinal;let a =index" class="plansscreen">
    
                      <span style="color:black">{{package?.name}}</span>
    
                      <div class="wraptext">
                        <div *ngFor="let group of package.groups;let k=index">
                          <div *ngFor="let plan of group.plans; let i = index">
                            <div *ngIf="plan.insuranceType!='LIFE'">
                              <div class="package-groups col-md-4" *ngFor="let product of plan.productAddonssNames; let r = index"
                                title=""
                                [style.background-color]="
                                                                              plan.isBundle==false?plan.productAddonss[product][0].planlevel.backgroundColor:group.backgroundColor||'#5E172E'">
    
                                <span class="plantitle"> <span style="color: white"
                                    *ngIf="group.categorization.paidByCompany==1">Company Paid Plans</span>
                                  <span style=" color: white" *ngIf="group.categorization.coveredByCompany==1">Upgrade Plans</span>
                                  <span style=" color: white"
                                    *ngIf="group.categorization.paidByEmployee==1">Voluntary Benefit(s) Plans</span><br><span
                                    style="padding-left:5px">{{product}}</span></span>
    
                                <div class="plancoverage ">
                                  <div class="plansCoverageDetails row col-12"
                                    *ngFor="let coverage of  plan.productAddonss[product]; let k = index">
    
                                    <!-- <span class="overflow-ellipsis2" style="float: right; color: white"
                                                                *ngIf="group.categorization.paidByCompany==1">&nbsp;<span
                                                                  style="float:right;color:white;font-size: 14px;">{{
                                                                  currencySymbol}}0.00<small>*</small></span></span> -->
    
    
    
                                    <div class="col-4" *ngIf="coverage?.display??false">
                                      <span class="overflow-ellipsis" style="float: left; color: white" title={{coverage.planCoverageUI}}>
    
                                        <input type="checkbox"
                                          id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"
                                          class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} {{group.categorization.paidByCompany==1?'cp_plan':group.categorization.coveredByCompany==1?'cc_plan':'ep_plan'}} coverage{{coverage.planCoverageUI | uppercase}}"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                     plan.planCoverage
                                   }}##{{plan.productAddonss[product][k].calculatedTax.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                     plan.frqMonthly
                                   }}##{{ package.optIn }}##{{
                                     group.disallowedPlanLevels
                                   }}##{{ group.parentId }}##{{ group.id }}##{{
                                     plan.name
                                   }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{plan.products && plan.products[k].upgradeCalculation?true:false}}"
                                          (change)="
                                                                             onCheckboxChangeCorporate(
                                       $event,
                                       package.allowMultiple,
                                       plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
                                       plan.planOptions,
                                       group.parentId,
                                       package.name,
                                       group.name,
                                       plan.planCoverage,
                                       0,
                                       0,
                                       0,
                                       0,
                                       $event,
                                       i,
                                       k,
                                       plan,
                                       plan.productAddonss[product][k],package,group)">
    
                                        {{coverage.planCoverageUI}}</span><span class="clearfix"></span>
                                    </div>
                                    <div class="col-8" *ngIf="coverage?.display??false">
                                      <span class="overflow-ellipsis2" style="float: right; color: white"
                                        *ngIf="group.categorization.paidByCompany==1">
                                        <span *ngIf="plan.products;else noProducts">
                                          <span *ngIf="plan.products[k] && plan.products[k].upgradeCalculation;else block1">
                                            <span *ngIf="plan.products[k].upgradeCalculation.deltaplanPrice<=0;else deltaplanPriceCheck">
                                              <span style="font-size: 14px;">You pay {{
                                                currencySymbol}}0.00<small>*</small></span>
                                            </span>
                                            <ng-template #deltaplanPriceCheck>
                                              <span style="font-size: 14px;float:right;color:white"> You pay through payroll deduction
                                                {{
                                                currencySymbol}}{{plan.products[k].upgradeCalculation.deltaplanPrice | number:
                                                "1.2-2"}}<small>*</small></span>
                                            </ng-template>
                                          </span>
                                          <ng-template #block1>
                                            <span *ngIf="plan.upgradeCalculation;else block2">
                                              <span *ngIf="plan.upgradeCalculation.deltaplanPrice<=0;else noDeltaplanPrice">
                                                <span style="font-size: 14px;color:white">You pay {{
                                                  currencySymbol}}0.00<small>*</small></span>
    
                                              </span>
                                              <ng-template #noDeltaplanPrice>
                                                <span style="font-size: 14px;float:right;color:white">You pay through payroll deduction
                                                  {{
                                                  currencySymbol}}{{plan.upgradeCalculation.deltaplanPrice | number:
                                                  "1.2-2"}}<small>*</small></span>
                                              </ng-template>
                                            </span>
                                          </ng-template>
                                          <ng-template #block2>
                                            <span>
                                              <span style="font-size: 14px;color:white">You pay {{
                                                currencySymbol}}0.00<small>*</small></span>
    
                                            </span>
    
                                          </ng-template>
    
    
                                        </span>
                                        <ng-template #noProducts>
                                          <span style="font-size: 14px;color:white">You pay {{
                                            currencySymbol}}0.00<small>*</small></span>
    
                                        </ng-template>
                                      </span>
    
                                      <span class="overflow-ellipsis2" style="float: right; color: white"
                                        *ngIf="group.categorization.coveredByCompany==1">
                                        <span style="float:right;color:white;font-size: 14px;">{{
                                          currencySymbol}}{{(plan.products?plan.products[k].upgradeCalculation.deltaplanPrice:plan.upgradeCalculation.deltaplanPrice)
                                          | number:
                                          "1.2-2"}}<small>*</small></span></span>
                                      <span class="overflow-ellipsis2" style="float: right; color: white"
                                        *ngIf="group.categorization.paidByEmployee==1"><span
                                          style="float:right;color:white;font-size: 14px;">{{
                                          currencySymbol}}{{coverage.price |
                                          number: "1.2-2" }}<small>*</small></span></span>
                                    </div>
                                  </div>
                                  <div class="taxes">
                                    <span *ngIf="group.categorization.paidByCompany==1" style="color:white">*Employee Pays</span>
                                    <span
                                      *ngIf="group.categorization.coveredByCompany==1" style="color:white">*Employee pays through payroll deduction</span>
                                    <span *ngIf="group.categorization.paidByEmployee==1" style="color:white"
                                      class="my-2">* Employee pays through CC/PAD</span>
    
                                  </div>
                                </div>
    
    
                                <!-- Member -->
    
    
    
    
    
                              </div>
                            </div>
    
    
    
                          </div>
                        </div>
                      </div>
    
    
                    </div>
                  </div>
          </div>
          
        <div class="modal-footer" *ngIf="!showChildForm">
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel (click)="closePopup('ViewBroucherPDF2')">Close</button>
          <button type="button" class="btn btn-primary" (click)="saveChanges()">Submit</button>
        </div>
        <div class="modal-footer" *ngIf="showChildForm">
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel (click)="closeHandleChildDetails()">Close</button>
          <button type="button" class="btn btn-primary" (click)="handleChildDetails_v2()">Update</button>
        </div>
      </div>
    </div>
  </div>



  <div class="modal fade" data-bs-backdrop="static" id="ViewBroucherPDF3" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h6 class="modal-title">Underwriting request email</h6>
          <div class="col-1 text-end ms-2 ms-md-2">
            <i style="margin-right: 4px" class="bi bi-x-circle" (click)="closePopup('ViewBroucherPDF3')" role="button" aria-hidden="true"
              data-bs-dismiss="modal"></i>
          </div>
        </div>
  
        <!-- Modal Body -->
        <div class="modal-body">
          <!-- To Email Input -->

          <div class="form-group">
            <div class="pdf-viewer" *ngIf="fileName != ''" style="border: 1px solid black; width: auto; height: 53px; padding: 10px;">
              <div class="pdf-file" style="display: flex; align-items: center; justify-content: space-between;">
                <div style="display: flex; align-items: center;">
                  <!-- PDF Icon -->
                  <img src="https://cdn-icons-png.flaticon.com/512/337/337946.png" 
                       alt="PDF Icon" 
                       style="width: 24px; height: 24px; margin-right: 10px;" />
          
                  <!-- File Name (click to download) -->
                  <a href="{{this.roeFile}}" 
                     download 
                     target="_blank"
                     style="text-decoration: none; color: black; font-weight: bold;">
                    {{fileName}}
                  </a>
                </div>
          
                <!-- Delete Button -->
                <button (click)="deleteRoeFile()" 
                        style="margin-left: 15px; padding: 4px 8px; background-color: red; color: white; border: none; cursor: pointer;">
                  Delete
                </button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="toEmail">Email</label>
            <input
              type="email"
              class="form-control"
              id="toEmail"
              name="toEmail"
              [(ngModel)]="toEmail"
              placeholder="Enter recipient email"
              required
              email
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              #toEmailRef="ngModel"
            />
        
            <div *ngIf="toEmailRef.invalid && toEmailRef.touched">
              <small *ngIf="toEmailRef.errors?.required" class="text-danger">Email is required.</small>
              <small *ngIf="toEmailRef.errors?.email" class="text-danger">Invalid email format.</small>
              <small *ngIf="toEmailRef.errors?.pattern" class="text-danger">Please enter a valid email address.</small>
            </div>
          </div>

          <!-- CC List Input -->
          <div class="form-group">
            <label for="ccList">CC List (Comma Separated)</label>
            <input type="text" class="form-control" id="ccList" [(ngModel)]="ccList" placeholder="Enter CC emails (e.g., email1@example.com, email2@example.com)">
          </div>
  
          <!-- Subject Input -->
          <div class="form-group">
            <label for="subject">Subject</label>
            <input type="text" class="form-control" id="subject" [(ngModel)]="subject" placeholder="Enter email subject">
          </div>
  
          <!-- Body Input -->
          <div class="form-group">
            <label for="body">Body</label>
            <textarea class="form-control" id="body" rows="5" [(ngModel)]="body" placeholder="Enter email body"></textarea>
          </div>        
        </div>
  
        <!-- Modal Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="closeEmailModal" data-bs-dismiss="modal" #closemodel (click)="closePopup('ViewBroucherPDF3')">Close</button>
          <!-- <button type="button" class="btn btn-secondary" id="closeEmailModal" data-bs-dismiss="modal" #closemodel (click)="saveAndClose('ViewBroucherPDF3')">Save & Close</button> -->
          <button type="button" class="btn btn-primary" (click)="sendEmail()">Send</button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" data-bs-backdrop="static" id="ViewBroucherPDF4" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content" id="reminder-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h6 class="modal-title">Add Reminder</h6>
          <div class="col-1 text-end ms-2 ms-md-2">
            <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
              data-bs-dismiss="modal"></i>
          </div>
        </div>
  
        <!-- Modal Body -->
        <div class="modal-body">
          <!-- Reminder Status Dropdown -->
          <div class="form-group">
            <label for="reminderStatus">Reminder Status</label>
            <select class="form-control" id="reminderStatus" [(ngModel)]="reminderStatus">
              <option value="Pending">Pending</option>
            </select>
          </div>
  
          <!-- Reminder Time Input -->
          <div class="form-group">
            <label for="reminderTime">Reminder Date</label>
            <input
            type="text"
            placeholder="MM-DD-YYYY"
            class="form-control checking-field"
            id="dob"
            [(ngModel)]="reminderTime"
            name="dob"
            bsDatepicker
            [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"
          />
          </div>
  
          <!-- Reminder Text Input -->
          <div class="form-group">
            <label for="reminderText">Reminder Text</label>
            <textarea class="form-control" id="reminderText" rows="3" [(ngModel)]="reminderText" placeholder="Enter reminder text"></textarea>
          </div>
        </div>
  
        <!-- Modal Footer -->
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="closeReminderModal" data-bs-dismiss="modal" #closemodel (click)="closePopup('ViewBroucherPDF4')">Close</button>
          <button type="button" class="btn btn-primary" (click)="saveReminder()">Save Reminder</button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" data-bs-backdrop="static" id="ViewBroucherPDF5" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="modal-title">History</h6>
          <div class="col-1 text-end ms-2 ms-md-2">
            <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
              data-bs-dismiss="modal"></i>
          </div>
        </div>
        <div class="modal-body">
  
          <div class="container">
            <ul class="notification-list">
              <li *ngFor="let hist of notificationHistory">
                {{ hist.date }} - <b>{{ hist.text }}</b>
                <br/>
                <i style="color: gray; font-size: 12px;" [innerHTML]="getParsedSubText(hist.subText)"></i>
              </li>
            </ul>
          </div>
        </div>
  
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closePopup('ViewBroucherPDF5')">
            Close
          </button>
  
        </div>
      </div>
    </div>
  </div>